import {configureStore} from '@reduxjs/toolkit'
import userSlice from './slices/userSlice'
import authSlice from './slices/authSlice'
import settingsSlice from "./slices/settingsSlice";
import workOrdersSlice from "./slices/workOrdersSlice";

const store = configureStore({
  reducer: {
    // Define a top-level state field named `todos`, handled by `todosReducer`
    user: userSlice,
    auth: authSlice,
    settings: settingsSlice,
	  workOrders: workOrdersSlice
  }
})


export default store
